const url = (process.env.PUBLIC_URL==='/'?'': process.env.PUBLIC_URL) ||'';
export const HOME_LOGIN = url + '/';
export const HOLIDAYS_FORM = url + '/holidays';
export const HOLIDAYS_CONFIRM = url + '/holidaysConfirm';
export const HOLIDAYS = url + '/allHolidays';
export const HOLIDAYS_CONSENT = '/consentHolidays';
export const HOLIDAY = url + '/holiday/:siteUrl/:holidayId';
export const HOLIDAY_VIEW = url + '/holidayView/:holidayId';
export const MY_HOLIDAYS = url + '/myHolidays';
;
